import styled from "styled-components";

import { Colors, Font, breakpoints, ColorDark } from "@/shared/Constants";
import { backgroundPhoto } from "../mixins-modules";
export const ContentOnexTwo = styled.div`
  width: 314px;
  height: 640px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  overflow: hidden;
  .contentVideo {
    aspect-ratio: 1/1;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      background: ${ColorDark.darkGrey};
    }
  }
  ${breakpoints.phone} {
    width: 100%;
    height: 100%;
  }
  .centergrey {
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    ${breakpoints.phone} {
      min-height: 212px;
      padding: 25px 0;
    }
  }
  .mt {
    width: 90%;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    h2.title {
      font-size: 25px;
      line-height: 28px;
      ${Font.clarinVarSub2Regular};
      ${breakpoints.phone} {
        font-size: 26px;
        line-height: 30px;
      }
    }
    .volanta {
      font-size: 25px;
      line-height: 25px;
      ${Font.clarinVarSub2Regular};
      ${breakpoints.phone} {
        font-size: 26px;
        line-height: 30px;
      }
    }
    .data-txt {
      justify-content: center;
    }
  }
  picture {
    height: 314px;
    width: 100%;
    ${breakpoints.phone} {
      height: 100%;
    }
    &::before {
      ${backgroundPhoto}
    }
    img {
      width: 100%;
      height: auto;
    }
  }

  .contentVideo {
    display: block;
    position: relative;
    height: auto;
    object-fit: cover;
    height: 314px;
    overflow: visible;
    ${breakpoints.phone} {
      min-height: 340px;
    }
    video {
      height: 314px;
      object-fit: cover;
      ${breakpoints.phone} {
        min-height: 340px;
        position: relative;
      }
    }
    ${breakpoints.phone} {
      width: 100%;
      min-height: 340px;
    }
  }
  .thumbnail-container img {
    height: 314px !important;
    min-height: 314px !important;
    width: 100%;
  }
  div.jwplayer {
    z-index: 4;
    height: 314px !important;
    min-height: 314px !important;
    aspect-ratio: 1;
    width: 100%;
    ${breakpoints.phone} {
      height: auto !important;
      min-height: auto !important;
    }
  }
`;
